module.exports = __webpack_public_path__ + "static/img/egg_g_10.321f53a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_10.png
// module id = ZBVN
// module chunks = 1